import { render, staticRenderFns } from "./SxnFour.vue?vue&type=template&id=36e875ff&"
import script from "./SxnFour.vue?vue&type=script&lang=js&"
export * from "./SxnFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/xampp/htdocs/riiqo-website-2020/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCol,VContainer,VRow})
